module.exports = __webpack_public_path__ + "static/media/work-6.546eebaa.png";